import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { deleteTemplateCategory } from '~/redux/actions/admin-templates-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

// utils
import { MESSAGES } from '~/utils/message';
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import { DeleteCDCIcon } from '~/assets/images';

const DeleteCategoryModal = (props) => {
  const { openModal, handleCloseModal, selectedTemplateCategory, pagination } = props;

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const deleteExistingCategory = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        deleteTemplateCategory(selectedTemplateCategory.id, pagination)
      );
      dispatch(success(response.data.message));
      handleCloseModal();
    } catch (error) {
      dispatch(failure(response?.data?.message || MESSAGES.GENERAL_ERROR));
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header: MESSAGES.ADMIN_DASHBOARD.CATEGORIES.DELETE.TITLE,
        message: MESSAGES.ADMIN_DASHBOARD.CATEGORIES.DELETE.HEADING,
        icon: DeleteCDCIcon,
        handleOk: deleteExistingCategory,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.ADMIN_DASHBOARD.CATEGORIES.DELETE.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.ADMIN_DASHBOARD.CATEGORIES.DELETE.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default DeleteCategoryModal;
